import { useState, useEffect, useRef } from 'react';
import { useAuth } from '../../contexts/AuthContext';

export const useAuthUserAndMembership = () => {
  const { user, loading, subscriptionActive, subscriptionLoading } = useAuth(); // Get real subscription status
  const [showLoginPopup, setShowLoginPopup] = useState(false);
  const [showSubscribePopup, setShowSubscribePopup] = useState(false);
  const prevUserRef = useRef(null);
  const hasInitiallyLoadedRef = useRef(false);
  const oAuthParametersDetectedRef = useRef(false);

  useEffect(() => {
    if (oAuthParametersDetectedRef.current) return; // Only check once

    const urlParams = new URLSearchParams(window.location.search);
    const urlHash = window.location.hash;

    // Check for OAuth parameters
    const hasOAuthParams = urlParams.has('code') ||
      urlParams.has('access_token') ||
      urlHash.includes('access_token') ||
      urlHash.includes('id_token') ||
      urlHash.includes('type=recovery') ||
      urlParams.has('token_type');

    const isSupabaseOAuth = urlHash.includes('#access_token') ||
      urlHash.includes('refresh_token') ||
      urlParams.has('code');

    if (hasOAuthParams || isSupabaseOAuth) {
      oAuthParametersDetectedRef.current = true;
    }
  }, []); // Empty dependency array - runs only once on mount




  
  useEffect(() => {
    // If still loading, don't do anything
    if (loading || subscriptionLoading || subscriptionActive === null) return;

    // Mark that we've completed the initial load
    if (!hasInitiallyLoadedRef.current) {
      hasInitiallyLoadedRef.current = true;
      prevUserRef.current = user;
      return; // Don't trigger popup on initial load
    }

    // Update the ref for next comparison (keep this for other useEffects that might need it)
    prevUserRef.current = user;
  }, [user, loading, subscriptionActive, subscriptionLoading]);


  useEffect(() => {
    const handleClick = (event) => {
      // Check if the clicked element or any parent has the correct class
      const target = event.target.closest('.read-user-and-membership');

      if (target) {
        if (loading || subscriptionLoading) {
          event.preventDefault(); // Prevent the original click
          event.stopPropagation(); // Stop event bubbling
          return;
        }

        if (!user) {
          // User is NOT logged in - show login popup
          event.preventDefault(); // Prevent the original click
          event.stopPropagation(); // Stop event bubbling
          setShowLoginPopup(true);
          // } else if (user && !subscriptionActive) {
        } else if (user && subscriptionActive === false) {
          // User is logged in but not a member - show subscribe popup
          event.preventDefault(); // Prevent the original click
          event.stopPropagation(); // Stop event bubbling
          setShowSubscribePopup(true);
        }
      }
    };

    // This ensures our handler runs before other click handlers
    document.addEventListener('click', handleClick, true);

    // Cleanup
    return () => {
      document.removeEventListener('click', handleClick, true);
    };
  }, [user, loading, subscriptionActive, subscriptionLoading]);



  const closeLoginPopup = () => {
    setShowLoginPopup(false);
  };

  const closeSubscribePopup = () => {
    setShowSubscribePopup(false);
  };

  return {
    showLoginPopup,
    showSubscribePopup,
    closeLoginPopup,
    closeSubscribePopup,
    subscriptionActive,
  };
};